import { getCustomerAutoshipSubscriptions } from '@libs/api-proxy-client';
import type { AutoshipCustomerApiResponse } from '@libs/common-types';
import { logger } from '@libs/core';

import createErrors from '../../constants/sentry/createErrors';
import { logSentryError } from '../../utils/sentryLogger';

type Page = 'Shared';
type Component = 'AutoshipAPI';

const SentryErrors = createErrors<Page, Component>('Shared')({
    AutoshipAPI: {
        FetchCustomerAutoshipSubscriptionsFailed: {
            severity: 'MEDIUM',
            message: 'Failed to fetch autoship data',
        },
    },
});

export async function fetchAutoshipSubscriptions(): Promise<AutoshipCustomerApiResponse> {
    try {
        return await getCustomerAutoshipSubscriptions();
    } catch (error) {
        logger.error('[FETCH CUSTOMER AUTOSHIP SUBSCRIPTIONS][Error]', error);
        logSentryError(error, SentryErrors.AutoshipAPI.FetchCustomerAutoshipSubscriptionsFailed);
        throw error;
    }
}
